import { render, staticRenderFns } from "./ConfirmedLifeInfo.vue?vue&type=template&id=70298e0e"
import script from "./ConfirmedLifeInfo.vue?vue&type=script&lang=js"
export * from "./ConfirmedLifeInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports